// import { injectReducer } from 'store/reducers'
// import { injectSagas } from 'store/sagas'

export default (store) => ({
  path: 'focus-tools-hub',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const FocusToolsHub = require('./containers/FocusToolsHubContainer').default
      // const reducer = require('./modules/reducer').default
      // const sagas = require('./modules/sagas').sagas

      /*  Add the reducer to the store on key 'focusToolsHub'  */
      // injectReducer(store, { key: 'focusToolsHub', reducer })
      // injectSagas(store, { key: 'focusToolsHub', sagas })

      /*  Return getComponent   */
      cb(null, FocusToolsHub)

    /* Webpack named bundle   */
    }, 'FocusToolsHub')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/FocusToolsHub/index.js
 **/